import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../common/LanguageSwitcher';
import PushNotificationControl from '../notifications/PushNotificationControl';

const CustomerPreferencesSections = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
        {t('language')}
      </Typography>
      <LanguageSwitcher />
      <Box sx={{ mt: 3 }}>
        <PushNotificationControl audience="customer" />
      </Box>
    </Box>
  );
};

export default CustomerPreferencesSections;
